import React from "react";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const LogFilter = ({ body, setBody }) => {
  const { t } = useTranslation();
  
  const moduleEnum = [
    "Auth",
    "Booking",
    "Invoice",
    "Hotel",
    "User Management",
    "Payment",
    "Report",
    "Notification",
    "Room Management",
    "Settings",
  ];
  const actionEnum = [
    "Created",
    "Updated",
    "Deleted",
    "Failed",
    "Approved",
    "Login",
    "Logout",
  ];

  const handleModuleChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, module: value, page: 1 }));
  };

  const handleActionChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, action: value, page: 1 }));
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, status: value, page: 1 }));
  };

  const handleCountryChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, country: value, page: 1 }));
  };

  const clearFilters = () => {
    setBody((prev) => ({
      ...prev,
      module: "",
      action: "",
      status: "",
      country: "",
      page: 1,
    }));
  };

  return (
    <div className="bg-white rounded-3 mb-1" style={{ fontSize: "14px" }}>
      <div className="d-flex flex-wrap gap-3 align-items-end">
        <div style={{ minWidth: "180px" }}>
          <Form.Label className="fw-semibold text-muted mb-1">
            {t("logManagement.filter.filterByModule")}
          </Form.Label>
          <Form.Select
            value={body.module || ""}
            onChange={handleModuleChange}
            className="shadow-sm mb-1"
          >
            <option value="">All Modules</option>
            {moduleEnum.map((module) => (
              <option key={module} value={module}>
                {module}
              </option>
            ))}
          </Form.Select>
        </div>

        <div style={{ minWidth: "150px" }}>
          <Form.Label className="fw-semibold text-muted mb-1">
            {t("logManagement.filter.filterByAction")}
          </Form.Label>
          <Form.Select
            value={body.action || ""}
            onChange={handleActionChange}
            className="shadow-sm mb-1"
          >
            <option value="">All Actions</option>
            {actionEnum.map((action) => (
              <option key={action} value={action}>
                {action}
              </option>
            ))}
          </Form.Select>
        </div>

        <div style={{ minWidth: "150px" }}>
          <Form.Label className="fw-semibold text-muted mb-1">
            {t("logManagement.filter.filterByStatus")}
          </Form.Label>
          <Form.Select
            value={body.status || ""}
            onChange={handleStatusChange}
            className="shadow-sm mb-1"
          >
            <option value="">All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
            <option value="Blocked">Blocked</option>
          </Form.Select>
        </div>

      
        <div className="d-flex align-items-end">
          <Button
            variant="secondary"
            size="sm"
            className="fw-semibold"
            style={{ height: 40, minWidth: 50 }}
            onClick={clearFilters}
          >
            {t("logManagement.filter.clear")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LogFilter;
